import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { setAnalyticsConsent } from '../utils/analytics';

const CONSENT_KEY = 'plum-cookie-consent';

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        setVisible(true);
      } else if (stored === 'accepted') {
        setAnalyticsConsent(true);
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch {}
    setAnalyticsConsent(true);
    setVisible(false);
  };

  const handleDecline = () => {
    try { localStorage.setItem(CONSENT_KEY, 'declined'); } catch {}
    setAnalyticsConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <p className="mb-0 me-3">
          We use cookies to improve your experience and analyze site usage.
          See our <a href="/privacy">Privacy Policy</a>.
        </p>
        <div className="d-flex gap-2 flex-shrink-0">
          <Button variant="outline-secondary" size="sm" onClick={handleDecline}>
            Decline
          </Button>
          <Button variant="primary" size="sm" onClick={handleAccept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
